import config from "@3gaam/api/config";

export const redirectToLogin = (shouldReturn?: boolean) => {
  let qs = "";
  if (shouldReturn) {
    qs += `ReturnUrl=${encodeURIComponent(window.location.href)}`;
  }
  window.location.replace(`${config.authenticateUrl}/Login?${qs}`);
};
